import moment from 'moment'
import React, { useContext, useMemo } from 'react'

import PriceDetails from '../Bookmark/BookmarkCardNew/PriceDetails'

import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import useBedbankRates from 'hooks/useBedbankRates'
import { min } from 'lib/array/arrayUtils'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { pluralizeToString } from 'lib/string/pluralize'

const defaultRoom: Array<App.Occupants> = [{ adults: 2 }]

type Props = {
  offer: App.BedbankOffer
  roomId?: string
  checkIn: string | moment.Moment
  checkOut: string | moment.Moment
}

function BedbankOfferPriceDetails({ offer, roomId, checkIn, checkOut }: Props) {
  const { currentRegionCode } = useContext(GeoContext)
  const [rates] = useBedbankRates(offer.id, defaultRoom, checkIn, checkOut)

  const rate = useMemo(() => {
    if (rates) {
      const filteredRates = roomId
        ? rates.filter((rate) => rate.roomId === roomId)
        : rates
      return min(filteredRates, (rate) => rate.totals.inclusive)
    }
  }, [rates, roomId])

  if (!rate) {
    return null
  }

  const taxExclusive =
    isEnabledForFeature(config.TAX_EXCLUSIVE_REGIONS, currentRegionCode) &&
    rate.totals.inclusive > rate.totals.exclusive
  const price = taxExclusive ? rate.totals.exclusive : rate.totals.inclusive

  return (
    <PriceDetails
      currencyCode={rate.currencyCode}
      price={price}
      discount={rate.discount}
      priceLabel={`${pluralizeToString('night', rate.nights)} from`}
      discountDisplayType="none"
      priceDisplayType={
        taxExclusive ? 'taxesAndFeesExclusive' : 'taxesAndFeesInclusive'
      }
    />
  )
}

export default BedbankOfferPriceDetails
